// Optional role/Thing descriptions beneath the title on Project Detail.
// - short only: shown as-is.
// - short + full: short line; "More" reveals the full text beneath it.
// - full only: first-sentence preview (word-boundary truncated at 120);
//   "More" swaps in the full text. No toggle when the preview is the
//   whole thing. Commitment controls always stay below this block.

import { useState } from "react";
import { ChevronDown } from "lucide-react";

const PREVIEW_MAX = 120;

export function previewFrom(full) {
  const text = full.trim();
  const firstLine = text.split(/\n/)[0].trim();
  const m = firstLine.match(/^.*?[.!?](?=\s|$)/);
  const sentence = (m ? m[0] : firstLine).trim();
  if (sentence.length <= PREVIEW_MAX) return sentence;
  const cut = sentence.slice(0, PREVIEW_MAX - 1);
  const atWord = cut.lastIndexOf(" ") > 40 ? cut.slice(0, cut.lastIndexOf(" ")) : cut;
  return `${atWord.replace(/[\s,;:–—-]+$/, "")}…`;
}

export default function RequirementDescription({ shortDescription, description, testIdPrefix }) {
  const [expanded, setExpanded] = useState(false);
  const short = (shortDescription || "").trim();
  const full = (description || "").trim();
  if (!short && !full) return null;

  const lead = short || previewFrom(full);
  const hasMore = !!full && full !== lead;
  const tid = (s) => (testIdPrefix ? `${testIdPrefix}-${s}` : undefined);
  const toggle = () => hasMore && setExpanded((v) => !v);
  // Full-only: the expanded text replaces the preview instead of repeating it.
  const showLead = !(expanded && !short);

  return (
    <div className="c-req-description-wrap">
      <div
        className={`c-req-description-text ${hasMore ? "is-expandable" : ""}`}
        onClick={toggle}
        data-testid={tid("description")}
      >
        {showLead ? (
          <div className="c-req-description c-req-description--short" data-testid={tid("description-short")}>
            {lead}
          </div>
        ) : null}
        {expanded ? (
          <div className="c-req-description c-req-description--full" data-testid={tid("description-full")}>
            {full}
          </div>
        ) : null}
      </div>
      {hasMore ? (
        <button
          type="button"
          className={`c-req-description-toggle ${expanded ? "is-open" : ""}`}
          onClick={toggle}
          aria-expanded={expanded}
          data-testid={tid("description-toggle")}
        >
          {expanded ? "Less" : "More"}
          <ChevronDown size={14} aria-hidden />
        </button>
      ) : null}
    </div>
  );
}
